/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './refund';
import './auth';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "CrossMethodRefund": {
                "fields": {
                  "cardRefundDetails": {
                    "type": ".squareup.esperanto.model.CrossMethodRefund.CardRefundDetails",
                    "id": 2
                  }
                },
                "nested": {
                  "CardRefundDetails": {
                    "fields": {
                      "cardRefund": {
                        "type": ".squareup.esperanto.model.Refund",
                        "id": 1,
                        "rule": "optional"
                      },
                      "card": {
                        "type": ".squareup.esperanto.model.Tender",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "destination_details": {
                    "oneof": ["cardRefundDetails"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CrossMethodRefund && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CrossMethodRefund?.nested?.CardRefundDetails) {
  $root.addJSON(jsonData);
}

/**
 * A refund to a destination method that is different from the source method of the payment being
 * refunded. Method, in this case, can be taken to mean any instance of an account or instrument,
 * i.e, a card to a different card, bank to recorded, recorded to card, etc.
 *
 * SOURCE CrossMethodRefund @ squareup/esperanto/model/cross_method_refund.proto at 15:1
 */
export const CrossMethodRefund = $root.lookupType('squareup.esperanto.model.CrossMethodRefund');
fixType(CrossMethodRefund);
Builder.createAndAttachToType(CrossMethodRefund);
/**
 * Details concerning a cross-method refund to a card.
 *
 * SOURCE CardRefundDetails @ squareup/esperanto/model/cross_method_refund.proto at 19:3
 */
CrossMethodRefund.CardRefundDetails = $root.lookupType('squareup.esperanto.model.CrossMethodRefund.CardRefundDetails');
fixType(CrossMethodRefund.CardRefundDetails);
Builder.createAndAttachToType(CrossMethodRefund.CardRefundDetails);